export default __webpack_public_path__ + "de1505e61652f01bed8c5326af0205eb.png";